import { RefundDialog } from "../store/RefundDialog";
import { type Registration, useRefundRegistration } from "./event-queries";

/** Refund a paid registration from the roster (ADR 0009; owner 2026-09-26). The dialog is shared with the store. */
export function RefundModal({
  registration,
  onClose,
}: {
  readonly registration: Registration;
  readonly onClose: () => void;
}) {
  const refund = useRefundRegistration();
  return (
    <RefundDialog
      title={`Refund ${registration.name}`}
      payer={registration.name}
      amountCents={registration.amountCents ?? 0}
      refundedCents={registration.refundedCents}
      currency={registration.currency}
      pending={refund.isPending}
      error={refund.error}
      onRefund={(amountCents, reason) => {
        refund.mutate(
          { registrationId: registration.id, amountCents, reason },
          { onSuccess: onClose },
        );
      }}
      onClose={onClose}
    />
  );
}
